import axios from 'axios'
import store from '@/store'
import router from '@/router'
// import { getToken } from 'utils/storage'
// import {Toast} from 'vant'
import qs from "qs"

import Toast from 'vant/lib/toast';
import "vant/lib/toast/style";
// 创建axios实例
const service = axios.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  timeout: 30000 // 请求超时时间30s
})

service.interceptors.request.use(
  config => {
    if (process.env.NODE_ENV !== 'development') {
      // 非本地开发环境，本地接口域名配置为动态域名，由URL是否是完整域名控制
      if (config.url.indexOf('http') !== -1) {
        // 发现url存在其他域名， 则设置baseURL为空
        config.baseURL = ''
      } else if (config.origin) {
        // 若存在接口属于公司其他域名下的且环境后缀统一， 则需要传参 origin 字段标识域名，如szone-my, szone-api
        // 从当前的host取下环境相关的字段。如 septnet.cn、stg2.septnet.cn、7net.cc
        let host = window.location.host.split('.')
        host.shift()
        host = host.join('.')
        config.baseURL = '//' + config.origin + '.' + host
      } else {
        config.baseURL = window.location.origin
      }
    }
    // 默认参数
    let requestParams = config.method === 'post' ? (config.data || {}) : (config.params || {})
    if (!config.noToken) requestParams.token = requestParams.token || store.state.token
    if (!requestParams.version) requestParams.version = '3.1.2'
    // 配置接口参数格式
    if (config.method === 'post') config.data = $.param(requestParams)
    return config
  },
  error => {
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.status !== 200) {
      if (res.status >= 400) { // 大于400给提示信息
        Toast({
          message: res.message,
          duration: 2000
        })
      }
      if (res.status === 401 || res.status === 402 || res.status === 408) {
        // 退出登录，此时先清除token，判断此页面是否强制登陆， 强制登陆的去登陆页面
        logoutout(store)
        // 取到当前路由的path
        let currentPath = window.location.hash.split('#')[1].split('?')[0]
        let routers = router.options.routes
        for (let i = 0, l = routers.length; i < l; i++) {
          let item = routers[i]
          if (currentPath === item.path) {
            // 找到对应路由的配置数据
            if (item.meta && item.meta.auth) {
              // 若是强制登陆的页面， 则去到登陆
              router.push('/login')
            }
          }
        }
      }
      return Promise.reject(res)
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error)
    Toast({
      message: "网络超时，请稍后重试",
      duration: 2000
    })
    return Promise.reject(error)
  }
)

function logoutout(store) {
  store.dispatch('act_logout').then(() => {})
}


export default service
